<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">操作日志</span></div>
		<div class="margin-top margin-left margin-right" style="display: flex;">
			<input type="text" v-model="action" placeholder="输入操作动作搜索，如：禁用" style="width: 200px;"
				   @keyup.enter="doSearch"/>
			<input type="text" v-model="operator" placeholder="输入操作人搜索" style="width: 160px; margin-left: 8px;"
				   @keyup.enter="doSearch"/>
			<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
			<Button style="margin-left: auto;" icon="fa fa-download" @click="exportCsv">导出 CSV</Button>
			<Button color="red" style="margin-left: 8px;" icon="fa fa-trash" @click="clearLogs">清理 90 天前</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="operatorName" title="操作人" :width="120"/>
				<TableItem prop="action" title="动作" :width="140"/>
				<TableItem prop="targetType" title="目标类型" :width="100" align="center"/>
				<TableItem prop="targetId" title="目标ID" :width="100" align="center"/>
				<TableItem prop="detail" title="详情"/>
				<TableItem prop="ip" title="来源IP" :width="120"/>
				<TableItem title="操作时间" :width="150">
					<template slot-scope="{data}">
						{{ data.createDate ? moment(data.createDate).format('YYYY-MM-DD HH:mm') : '' }}
					</template>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminLogs",
		data() {
			return {
				loading: false,
				action: '',
				operator: '',
				dataList: [],
				pagination: {
					page: 1,
					size: 20,
					total: 0
				}
			}
		},
		methods: {
			moment,
			loadList() {
				this.loading = true;
				this.$api.admin.logs({
					page: this.pagination.page,
					size: this.pagination.size,
					action: this.action || undefined,
					operator: this.operator || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			exportCsv() {
				window.open(this.$api.admin.logsExportUrl({action: this.action, operator: this.operator}), '_blank');
			},
			clearLogs() {
				this.$Confirm('确认清理 90 天前的操作日志？此操作不可恢复。').then(() => {
					this.$api.admin.clearLogs({days: 90}).then(({msg}) => {
						this.$Message.success(msg || '清理完成');
						this.loadList();
					});
				});
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
